import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#FFDA44\" d=\"m6.504 22.67 8.816-7.35 7.35-8.816a12.05 12.05 0 0 0-5.169-5.172L8.68 8.679 1.332 17.5a12.05 12.05 0 0 0 5.172 5.169\"></path><path fill=\"#D80027\" d=\"M20.484 20.485c3.786-3.786 4.513-9.472 2.182-13.988l-16.17 16.17c4.516 2.33 10.202 1.604 13.988-2.182\"></path><path fill=\"#6DA544\" d=\"M3.514 3.514C-.272 7.3-.998 12.985 1.332 17.502l16.17-16.17C12.986-1 7.3-.272 3.514 3.514\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }